export { default } from './analytics-wrapper.component';
